// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1913":"1dd98e602e9f51d4","4121":"0406710406c7acd3"}[chunkId] + ".css";
};